export * from './post-gutachten.component';
export * from './post-gutachten.component.module';